import * as React from 'react';
const SvgRefresh = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 14" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 12A5 5 0 017 2a4.94 4.94 0 013.316 1.282L8 5.402l7.002 1.725L13.901 0l-2.097 1.92A6.958 6.958 0 007 0a7 7 0 103.678 12.953 6.995 6.995 0 002.578-2.825l-1.801-.901C10.633 10.865 8.957 12 7 12z"
            fill="currentColor"
        />
    </svg>
);
export default SvgRefresh;
